import { Component, OnInit, NgZone } from '@angular/core';
import { FlowDataService } from '../../services/flow-data.service';
import { HydroConditionService } from '../../services/hydro-condition.service';

var BreakException = {};

@Component({
    selector: 'date-condition',
    templateUrl: 'date-condition.component.html',
    styleUrls: ['date-condition.component.scss']
})

export class DateConditionComponent implements OnInit {

    public efdate = ''; //used to store the data selected
    public ef200count = 0; // counter for reaches with excess flow above 200cfs threshold

    date: string;
    ReachLeaf: any;
    ReachLeaf2: any;
    geoJsonData: any;
    flowData: any;
    ReachNumber: string;
    correlation: object;
    hydroCondition: string;
    targetFlowData: any;

    constructor(private flowDataObject: FlowDataService, private zone: NgZone, private hydroConditionService: HydroConditionService) { }

    ngOnInit() {

        this.flowDataObject.currentFlow.subscribe(flowData => {
            this.flowData = flowData;
          this.setSubsciptions();
        });

        this.hydroConditionService.currentHydroCondition.subscribe(hydroCondition => {
            if (hydroCondition) { //can replace "if" with "optional chaining" after Angular 9/typescript upgrade
                this.hydroCondition = hydroCondition.demandCondition;
            }
        });

    }

    setSubsciptions = () => {
            if (Array.isArray(this.flowData) && this.flowData.length) {
                this.correlation = {};
                for (let i = 0; i < this.flowData.length; i++) {
                    this.correlation[this.flowData[i].ReachNumber] = i;
                }

                this.efdate = this.flowData[0].ExcessFlowDate.toString();
                this.ef200count = 0;

                /* Generated gradient array using https://codepen.io/BangEqual/pen/VLNowO */
                let gradient = ["#330acc", "#661499", "#991f66", "#cc2933"];
                let thicknessArr = [2.5, 3, 3.5, 4];


                var r9clr = '';
                var r9wgt = 0;

                for (let i = 0; i < this.flowData.length; i++) {
                    this.correlation[this.flowData[i].ReachNumber] = i;

                    /* Style reach based on excessflow value */
                    var val = Number(this.flowData[i].ExcessFlow);

                    if (val > 200) {
                        this.ef200count += 1;
                    }

                    let closest;

                    if (this.flowData[i].ExcessFlow < 100) { closest = 0; }
                    else if (this.flowData[i].ExcessFlow < 500) { closest = 1; }
                    else if (this.flowData[i].ExcessFlow < 1000) { closest = 2; }
                    else { closest = 3; }

                    let clr = gradient[closest];
                  let wgt = thicknessArr[closest];

                  /* Get flow data for target at Grand Island */
                  if (this.flowData[i].ReachNumber == 16) {
                    this.targetFlowData = this.flowData[i];
                  }
                }
            }
    }


}
